// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H7.33057L7.33057 22H2V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.33471 2H14.6653V22H9.33471V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2H16.6694V22H22V2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-frame-1-filled')
export default class Frame1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'frame-1-filled',
    }
  }
}
